import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Image from 'next/image'
import { RegularSection, ColorTitle } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'
import { resolveHref } from '@/utilites/resolveHref'

interface ImageData {
    src?: string
    alt?: string
}

interface ButtonData {
    text?: string
    link?: string
}

interface Content {
    image?: ImageData
    title?: string
    text1?: string
    text2?: string
    button?: ButtonData
}

interface S2_Hero_3Props {
    content?: Content
    blockName?:string
}

const Index = (props: S2_Hero_3Props) => {
    const { content = {} } = props
    const { image = {}, title, text1, text2, button = {} } = content
    const heroImage = getImageData(image)
    const buttonHref = resolveHref(button.link, '#')
    return (
        <RegularSection aria-label='S2_Hero_3' >
            <Grid
                container
                spacing={4}
            >
                <Grid
                    size={{ xs: 12, md: 6, lg: 5 }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 5,
                        overflow: 'hidden',
                    }}
                >
                    {heroImage.src ? (
                        <Image
                            src={heroImage.src}
                            alt={heroImage.alt || ''}
                            width={670}
                            height={360}
                            style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                        />
                    ) : null}
                </Grid>
                <Grid
                    size={{ xs: 12, md: 6, lg: 7 }}
                    sx={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center' }}
                >
                    <ColorTitle title={title} colorFrom={0} textAlign='start' width='100%'/>
                    <Typography variant='body2'>{text1}</Typography>
                    <Typography variant='body2'>{text2}</Typography>
                    <Button
                        variant='contained'
                        color='primary'
                        href={buttonHref}
                        size='large'
                        sx={{ width: { xs: '100%', md: 'fit-content'} }}
                    >
                        {button.text || 'Contact us now'}
                    </Button>
                </Grid>
            </Grid>
        </RegularSection>
    )
}

export default Index
